export const THEME_BUILDER_EVENTS = {
	SAVE: 'Save'
}